/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { useLocation, useNavigate } from 'js/lib/useRouter';

import { Button } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import _t from 'i18n!nls/composable-page-header-consumer';

const styles = {
  joinForFreeButton: css`
    margin-left: var(--cds-spacing-50);

    /* Hide the button on the small screens where space is limited */
    @media (max-width: 435px) {
      display: none;
    }
  `,
};

const MobileJoinForFreeButton = () => {
  const track = useTracker();
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = () => {
    track('click_button', {
      button: { name: 'signup' },
      pageSection: { sectionName: 'sticky_page_navigation' },
    });

    const searchParams = new URLSearchParams(location?.search || '');
    searchParams.set('authMode', 'signup');

    navigate(
      {
        pathname: location?.pathname || '/',
        search: `?${searchParams.toString()}`,
      },
      { replace: true }
    );
  };

  return (
    <Button size="small" variant="secondary" onClick={handleClick} css={styles.joinForFreeButton}>
      {_t('Join for Free')}
    </Button>
  );
};

export default MobileJoinForFreeButton;
